module.exports = __webpack_public_path__ + "static/jinhwanchoi.jiyoung.chae-1d10c141fcd2ba2db9d20e5374066556.jpeg";